var map = {
	"./background_mainPage.png": 251,
	"./card1_featuresSection.png": 206,
	"./card2_featuresSection.png": 761,
	"./card3_featuresSection.png": 458,
	"./card4_featuresSection.png": 410,
	"./hero_mainPage.png": 188,
	"./team_anton_gorshkov.png": 982,
	"./team_sergey_pobudey.png": 479,
	"./team_zmitser_furmanau.png": 758
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 548;